<script setup lang="ts">
import BgrLine from 'assets/bgr-lines/line-login-1.svg';
</script>

<template>
  <main>
    <BgrPictureWide class="-z-10 bottom-2/4 w-full h-screen bg-gray-300 relative">
      <BgrLine class="w-full h-auto top-2/4 -translate-y-2/4 absolute" />
    </BgrPictureWide>
    <NuxtPage />
  </main>
</template>

<style scoped>

</style>
